import { InjectionToken } from "@angular/core";

export const DATA_SERVICE = new InjectionToken<DataService>("DataService");

export interface DataService {
  feedbackFormClick: any;
  onFeedbackFormClick(arg0: boolean): void;
}